import React from 'react';
import PropTypes from 'prop-types';
import axios from 'axios';
import SovosEditableSlidingPanel from 's1-ui/sovos-sliding-panel/SovosEditableSlidingPanel';
import {
  SLIDING_PANEL_DIALOG_ACTION_LABEL,
  SLIDING_PANEL_DIALOG_CONTENT_CLASS_NAME,
  SLIDING_PANEL_DIALOG_TEXT,
  SLIDING_PANEL_DIALOG_TITLE,
  SLIDING_PANEL_DIALOG_TITLE_CLASS_NAME
} from 'shared/constants/SharedConstants';
import InvoiceLineEditor from './InvoiceLineEditor';

const defaultValidationErrorMessage = 'Invalid input. Enter a different value.';

class InvoiceLineEditorSlidingPanel extends React.PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      invoiceLineData: props.invoiceLineData,
      invoiceLineNumber: props.invoiceLineData.number,
      fetchingInvoiceLineData: false,
      disableSaveButton: true,
      fieldsTouched: {}
    };
  }

  componentWillReceiveProps = nextProps => {
    if (this.props.invoiceLineData !== nextProps.invoiceLineData) {
      this.setState({
        invoiceLineData: nextProps.invoiceLineData,
        invoiceLineNumber: nextProps.invoiceLineData.number
      });
    }
  };
  
  saveInvoiceLineData = invoiceLineData => {
    this.setState({ 
      disableSaveButton: true,
      fetchingInvoiceLineData: true
    });
    axios
      .put(`utm/v1/invoice-lines`, invoiceLineData)
      .then(() => {
        this.props.invoicesActions.fetchInvoiceJurisdictionalBreakdown(this.state.invoiceLineData.id);
        this.props.invoicesActions.fetchInvoiceById(this.props.invoiceData.id);
        this.props.onClose();
        this.setState({
          fetchingInvoiceLineData: false
        });
      })
      .catch(err => { throw err; });
  };

  onCloseSlidingPanel = () => {
    this.setState({ disableSaveButton: true });
    this.props.onClose();
  };

  handleCheckInputError = () => {
    const inputErrorMessages = Object.values(this.state.fieldsTouched);
    this.setState({
      disableSaveButton: inputErrorMessages.indexOf(defaultValidationErrorMessage) > - 1
    });
  }

  handleInputChange = (name, value, errorMessage) => {    
    this.setState(
      oldState => ({
        invoiceLineData: { ...oldState.invoiceLineData, [name]: value },
        fieldsTouched: {...oldState.fieldsTouched, [name]: errorMessage }
      }), () => this.handleCheckInputError()
    );
  };

  handleSaveButtonClick = () => this.saveInvoiceLineData(this.state.invoiceLineData);

  render () {
    const { open, invoiceNumber } = this.props;
    const {
      fetchingInvoiceLineData,
      invoiceLineNumber,
      disableSaveButton,
      invoiceLineData
    } = this.state;
    return (
      <SovosEditableSlidingPanel
        open={ open }
        onClose={ this.onCloseSlidingPanel }
        isDirty={ () => true }
        baseWidth={ '1230px' }
        title={ `Line ${invoiceLineNumber} - Invoice ${invoiceNumber}` }
        dialogTitle={ SLIDING_PANEL_DIALOG_TITLE }
        dialogText={ SLIDING_PANEL_DIALOG_TEXT }
        dialogContentClassName={ SLIDING_PANEL_DIALOG_CONTENT_CLASS_NAME }
        dialogActionLabel={ SLIDING_PANEL_DIALOG_ACTION_LABEL }
        SaveButtonProps={ {
          onClick: this.handleSaveButtonClick,
          disabled: disableSaveButton,
          children: 'SAVE'
        } }
        CancelButtonProps={ {
          children: 'CANCEL'
        } }
        CloseDialogProps={ {
          DialogTitleProps: {
            children: SLIDING_PANEL_DIALOG_TITLE,
            className: SLIDING_PANEL_DIALOG_TITLE_CLASS_NAME
          },
          DialogContentProps: {
            children: SLIDING_PANEL_DIALOG_TEXT,
            className: SLIDING_PANEL_DIALOG_CONTENT_CLASS_NAME
          },
          OKButtonProps: {
            children: SLIDING_PANEL_DIALOG_ACTION_LABEL
          },
          CancelButtonProps: {
            children: 'CANCEL'
          }
        } }
      >
        <InvoiceLineEditor
          invoiceLineData={ invoiceLineData }
          onFieldChange={ this.handleInputChange }
          fetchingInvoiceLineData={ fetchingInvoiceLineData }
        />
      </SovosEditableSlidingPanel>
    );
  }
}

InvoiceLineEditorSlidingPanel.propTypes = {
  open: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  invoiceNumber: PropTypes.string.isRequired,
  invoiceLineData: PropTypes.object.isRequired,
  invoiceData: PropTypes.object,
  invoicesActions: PropTypes.shape({
    fetchInvoiceById: PropTypes.func,
    fetchInvoiceJurisdictionalBreakdown: PropTypes.func
  })
};

export default InvoiceLineEditorSlidingPanel;



// WEBPACK FOOTER //
// ./src/components/viewTransactions/viewTransactionsGrid/c/invoiceLinesSlidingPanel/invoiceLinesDetail/c/invoiceLineEditor/InvoiceLineEditorSlidingPanel.js